module.exports = __webpack_public_path__ + "media/assets/img/activitati-06accb46a38fb460133fe0d01863675b.svg";